import { useContext, useRef, useEffect } from 'react';

import ClientContext from './ClientContext';
import { reportException } from 'src/exceptionReporting';

interface Options {
  client?: any;
  query: string;
  variables: any;
  ignoreInitialCallBack?: boolean;
}

const useSubscription = (contextClient: any, options: Options, callback: any) => {
  const callbackRef = useRef(callback);
  const initializeRef = useRef(false);

  callbackRef.current = callback;

  const client = options.client || contextClient;
  if (!client) {
    throw new Error(
      'useSubscription() requires a client to be passed in the options or as a context value'
    );
  }
  const request = {
    query: options.query,
    variables: options.variables,
  };

  useEffect(() => {
    const observable = client.createSubscription(request);
    const subscription = observable.subscribe({
      next: (result: any) => {
        if (!options.ignoreInitialCallBack || (options.ignoreInitialCallBack && initializeRef.current)) {
          callbackRef.current(result);
        }
        initializeRef.current = true;
      },
      error: (error:any) => {
        subscription.unsubscribe();
        initializeRef.current = false;
        reportException("------User subscription---------------", error)
      },
      complete: () => {
        initializeRef.current = false;
        subscription.unsubscribe();
      },
    });
    return () => {
      subscription.unsubscribe();
    };
  }, []); // eslint-disable-line
  // the effect should be run when component is mounted and unmounted
};

export const useSubscriptionApplication = (options: Options, callback: any) => {
  // @ts-ignore
  const { applicationClient } = useContext(ClientContext);

  return useSubscription(applicationClient, options, callback);
};
